<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: mapState(["user"]),

  mounted() {
    window.civchat = {
      apiKey: "neswlv",
    };
  },
};
</script>

<style>
@font-face {
  font-family: "SofiaProBoldAz";
  src: local("SofiaProBoldAz"),
    url(./fonts/SofiaProBoldAz.otf) format("truetype");
}

@font-face {
  font-family: "SofiaProBlackAz";
  src: local("SofiaProBlackAz"),
    url(./fonts/SofiaProBlackAz.otf) format("truetype");
}

@font-face {
  font-family: "SofiaProLightAz";
  src: local("SofiaProLightAz"),
    url(./fonts/SofiaProLightAz.otf) format("truetype");
}

@font-face {
  font-family: "SofiaProExtraLightAz";
  src: local("SofiaProExtraLightAz"),
    url(./fonts/SofiaProExtraLightAz.otf) format("truetype");
}
@font-face {
  font-family: "SofiaProMediumAz";
  src: local("SofiaProMediumAz"),
    url(./fonts/SofiaProMediumAz.otf) format("truetype");
}

@font-face {
  font-family: "SofiaProRegularAz";
  src: local("SofiaProRegularAz"),
    url(./fonts/SofiaProRegularAz.otf) format("truetype");
}

@font-face {
  font-family: "SofiaProSemiBoldAz";
  src: local("SofiaProSemiBoldAz"),
    url(./fonts/SofiaProSemiBoldAz.otf) format("truetype");
}

@font-face {
  font-family: "SofiaProUltraLightAz";
  src: local("SofiaProUltraLightAz"),
    url(./fonts/SofiaProUltraLightAz.otf) format("truetype");
}

body {
  background-image: url('./assets/retailers_background.svg');
  background-repeat: no-repeat;
}

.container {
  max-width: 1400px !important;
}

#app {
  font-family: "Montserrat";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.centeralign {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

fieldset[disabled] .multiselect {
  pointer-events: none;
}
.multiselect__spinner {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 48px;
  height: 35px;
  background: #fff;
  display: block;
}
.multiselect__spinner:after,
.multiselect__spinner:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border-color: #41b883 transparent transparent;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 0 0 1px transparent;
}
.multiselect__spinner:before {
  animation: a 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.multiselect__spinner:after {
  animation: a 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.multiselect__loading-enter-active,
.multiselect__loading-leave-active {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.multiselect__loading-enter,
.multiselect__loading-leave-active {
  opacity: 0;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-family: inherit;
  font-size: 16px;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}
.multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;
  color: #35495e;
}

.multiselect * {
  box-sizing: border-box;
}
.multiselect:focus {
  outline: none;
}
.multiselect--disabled {
  opacity: 0.6;
}
.multiselect--active {
  z-index: 1;
}
.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: none !important;
}
.multiselect--active .multiselect__select {
  transform: rotate(180deg);
}
.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: none !important;
}
.multiselect__input,
.multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: none;
  border-radius: 5px;
  padding: 0 0 0 5px;
  width: 100%;
  transition: border 0.1s ease;
  box-sizing: border-box;
  margin-bottom: 8px;
  vertical-align: top;
  color: #c5c5c5;
  background: none !important;
}
.multiselect__input::-webkit-input-placeholder {
  color: #35495e;
}
.multiselect__input:-ms-input-placeholder {
  color: #35495e;
}
.multiselect__input::placeholder {
  color: #35495e;
}
.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single {
  width: auto;
}
.multiselect__input:hover,
.multiselect__single:hover {
  border-color: #cfcfcf;
}
.multiselect__input:focus,
.multiselect__single:focus {
  border-color: #a8a8a8;
  outline: none;
}
.multiselect__single {
  padding-left: 5px;
  margin-bottom: 8px;
}
.multiselect__tags-wrap {
  display: inline;
}
.multiselect__tags {
  height: 70px;
  border: none;
  border-bottom: 2px solid #57f3bb;
  font-size: 30px;
  text-align: left;
  font-family: "SofiaProBlackAz";
  color: #000;
  font-weight: 400;
  padding-right: 15px;
  padding-left: 15px;
  display: flex;
  align-items: center;
  align-content: center;
}
.multiselect__tag {
  color: #000;
  position: relative;
  display: inline-block;
  padding: 15px;
  border-radius: 5px;
  margin-right: 10px;
  line-height: 1;
  background: none;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
}
.multiselect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 2px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 11px;
  background: #57f3bb;
}
.multiselect__tag-icon:after {
  content: "\D7";
  color: #fff;
  font-size: 18px;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #57f3bb;
}
.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: #fff;
}
.multiselect__current {
  min-height: 40px;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
}
.multiselect__current,
.multiselect__select {
  line-height: 16px;
  box-sizing: border-box;
  display: block;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
}
.multiselect__select {
  position: absolute;
  width: 40px;
  height: 38px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  text-align: center;
  transition: transform 0.2s ease;
  visibility: hidden;
}
.multiselect__select:before {
  position: relative;
  right: 0;
  top: 65%;
  color: #999;
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0;
  border-color: #680e01 transparent transparent;
  content: "";
}
.multiselect__placeholder {
  color: #c5c5c5;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
  font-weight: 400;
  font-family: "SofiaProLightAz";
  font-size: 20px;
}
.multiselect--active .multiselect__placeholder {
  display: none;
}
.multiselect__content-wrapper {
  position: absolute;
  display: flex;
  background: none;
  width: 100%;
  max-height: 140px;
  overflow: hidden;
  border: none !important;
  border-top: none !important;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
}
.multiselect__content {
  list-style: none;
  display: flex !important;
  padding: 0;
  margin: 0;
  vertical-align: top;
}
.multiselect--above .multiselect__content-wrapper {
  bottom: 0 !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #e8e8e8;
  font-size: 14px;
}
.multiselect__content::webkit-scrollbar {
  display: none;
}
.multiselect__element {
  display: block;
  background: none;
  padding: 15px;
}
.multiselect__option {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  background-color: #57f3bb;
  color: #fff;
  border-radius: 3px;
  box-shadow: 7px 6px 21px -4px rgb(54 74 13 / 12%);
  text-align: center;
  line-height: 30px;
  padding: 10px;
  cursor: pointer;
  min-width: 120px;
  height: 50px;
  font-size: 11px;
}

.select-followers .multiselect__option {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: row;
  background-color: #57f3bb;
  color: #fff;
  border-radius: 3px;
  border: solid 1px #57f3bb;
  box-shadow: 7px 6px 21px -4px rgb(54 74 13 / 12%);
  text-align: center;
  line-height: 30px;
  padding: 10px;
  cursor: pointer;
  height: 100px;
  background: #fff;
  color: #000;
}

.multiselect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
  font-size: 13px;
}
.multiselect__option--highlight {
  background: #dbddee;
  outline: none;
  color: #201e4f;
}
.multiselect__option--highlight:after {
  background: #dbddee;
  color: #201e4f;
}
.multiselect__option--selected {
  background: #f3f3f3;
  color: #35495e;
  font-weight: 700;
}
.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  /* content: attr(data-deselect); */
  color: #fff;
}
.multiselect--disabled {
  background: #ededed;
  pointer-events: none;
}
.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select,
.multiselect__option--disabled {
  background: #ededed;
  color: #a6a6a6;
}
.multiselect__option--disabled {
  cursor: text;
  pointer-events: none;
}
.multiselect__option--group {
  background: #ededed;
  color: #35495e;
}
.multiselect__option--group.multiselect__option--highlight {
  background: #35495e;
  color: #fff;
}
.multiselect__option--group.multiselect__option--highlight:after {
  background: #35495e;
}
.multiselect__option--disabled.multiselect__option--highlight {
  background: #dedede;
}
.multiselect__option--group-selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  /* content: attr(data-deselect); */
  color: #fff;
}
.multiselect-enter-active,
.multiselect-leave-active {
  transition: all 0.15s ease;
}
.multiselect-enter,
.multiselect-leave-active {
  opacity: 0;
}
.multiselect__strong {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}
[dir="rtl"] .multiselect {
  text-align: right;
}
[dir="rtl"] .multiselect__select {
  right: auto;
  left: 1px;
}
[dir="rtl"] .multiselect__tags {
  padding: 8px 8px 0 40px;
}
[dir="rtl"] .multiselect__content {
  text-align: right;
}
[dir="rtl"] .multiselect__option:after {
  right: auto;
  left: 0;
}
[dir="rtl"] .multiselect__clear {
  right: auto;
  left: 12px;
}
[dir="rtl"] .multiselect__spinner {
  right: auto;
  left: 1px;
}

@keyframes a {
  0% {
    transform: rotate(0);
  }
  to {
    transform: rotate(2turn);
  }
}

@media only screen and (max-width: 768px) {
  .select-followers .multiselect__option {
  }
  .multiselect__option {
    line-height: normal;
    padding: 10px;
    cursor: pointer;
    min-width: 120px;
    height: 30px;
    font-size: 10px;
    display: flex;
    flex-wrap: wrap;
    height: 40px;
    min-width: auto;
    font-size: 8px;
  }
  .select-followers .multiselect__tags {
    margin-bottom: 100px;
    font-size: 8px;
    height: 40px;
  }
  .multiselect__tags {
    height: 30px;
    margin-bottom: 30px;
    font-size: 14px;
  }
  .multiselect__tag {
    font-size: 14px;
  }
  .multiselect__placeholder {
    font-size: 14px;
  }
  .multiselect__tag-icon {
    width: 15px;
    height: 15px;

    line-height: 10px;
  }
}
</style>
